/*
 *
 * NexiClubWaiverPopup
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 09-Jul-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  waiverTitle: (
    <PortalMessage
      id='t.app.nexiclub.waiver.title'
      defaultMessage='Sei sicuro di voler rinunciare a ricevere informazioni sulle iniziative di Nexi?'
    />
  ),
  waiverDescription: (
    <PortalMessage
      id='t.app.nexiclub.waiver.description'
      defaultMessage='Se rinunci, <b>non potrai ricevere offerte esclusive</b>, premi ed esperienze imperdibili.'
    />
  ),
  waiverPrimaryButton: (
    <PortalMessage
      id='t.app.nexiclub.waiver.primaryButton'
      defaultMessage='Si, rinuncio'
    />
  ),
  waiverSecondaryButton: (
    <PortalMessage
      id='t.app.nexiclub.waiver.secondaryButton'
      defaultMessage='No'
    />
  )
}

export default formattedMessage
